import React, { useEffect } from 'react'
import TextField from '@material-ui/core/TextField'
import EditorSection from './EditorSection'
import TitleEditor from './TitleEditor'
import { theme } from "../../theme";
import { withStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

export const editorSections = {
    description : "Description",
    biological_hazard: "Biological Hazard",
    bh_rlto:"Is this biological hazard RLTO?",
    bh_justification: "Biological hazard justification", 
    chemical_hazard: "Chemical Hazard",
    ch_rlto:"Is this chemical hazard RLTO?",
    ch_justification: "Chemical hazard justification", 
    physical_hazard: "Physical Hazard",
    ph_rlto:"Is this physical hazard RLTO?",
    ph_justification: "Physical hazard justification",
    measures: "Measures to prevent, eliminate or reduce Hazards",
    ccp: "Is this step a CCP?", 
}

const ColorSwitch = withStyles({
    switchBase: {
        color: theme.colors.secondary,
        '&$checked': {
            color: theme.colors.secondary,
          },
        '&$checked + $track': {
            backgroundColor: theme.colors.secondary,
          },
    },
    checked: {},
    track: {},
})(Switch);

const YesNoSwitcher = ({ checked, onChange, label }) => {
    return (
        <Grid component="label" container alignItems="center" spacing={1} style={{paddingLeft:'10%', marginBottom: 30}}>
            <Grid item><Typography variant="subtitle2" noWrap>{label}</Typography></Grid>
            <Grid item>No</Grid>
            <Grid item>
                <ColorSwitch checked={checked} onChange={onChange} name="checkedC" />
            </Grid>
            <Grid item>Yes</Grid>
        </Grid>
    )
}

export default function({
    handleFormChange, 
    setActiveSection, 
    setUploadOpen,
    sopState,
    setSopState,
    attachments,
    children, 
}){

    const { 
        biological_hazard,
        bh_rlto,
        bh_justification, 
        chemical_hazard,
        ch_rlto,
        ch_justification, 
        physical_hazard,
        ph_rlto,
        ph_justification,
        measures,
        ccp, 
    } = { ... attachments?.attachments?.hs }
    
    const handleOnClick = (section) => {
        setActiveSection(section)
        setUploadOpen(true)
    }
    
    const handleOnUpdate = (section, val) => {
        setSopState({...sopState, [section]: val})
    }

    useEffect( () => {
        const nInitState = {
            ...( !sopState.hasOwnProperty('bh_rlto') && { bh_rlto: false }),
            ...( !sopState.hasOwnProperty('ch_rlto') && { ch_rlto: false }),
            ...( !sopState.hasOwnProperty('ph_rlto') && { ph_rlto: false }),
            ...( !sopState.hasOwnProperty('ccp') && { ccp: false }),
        }
        setSopState({...sopState, ...nInitState});
    }, [])

    return (
        <div>
            <h2>Hazards Steps Editor</h2>
            <form noValidate autoComplete="off">
                <div>
                    <TextField id="title" label="Process Step" value={sopState.title} 
                    onChange={(e) => handleFormChange(e)} 
                    style={{width:'80%', marginBottom:20}}
                    />
                </div>
                <div>
                    <TextField id="description" label={editorSections.description} value={sopState.description} 
                    onChange={(e) => handleFormChange(e)} 
                    style={{width:'80%', marginBottom:20}}
                    />
                </div>
                <EditorSection 
                    sectionName={editorSections.biological_hazard}
                    onClick={ () => { handleOnClick('biological_hazard')}}
                    html={sopState?.biological_hazard}
                    onUpdate={ (val) => { handleOnUpdate('biological_hazard', val) }}
                    attachment={biological_hazard}
                />
                <YesNoSwitcher 
                    label={editorSections.bh_rlto} 
                    checked={ (typeof sopState.bh_rlto === 'boolean') ? sopState.bh_rlto : false } 
                    onChange={ (e) => { 
                        handleOnUpdate('bh_rlto', e.target.checked)
                    }}  
                />
                <EditorSection 
                    sectionName={editorSections.bh_justification}
                    onClick={ () => { handleOnClick('bh_justification')}}
                    html={sopState?.bh_justification}
                    onUpdate={ (val) => { handleOnUpdate('bh_justification', val) }}
                    attachment={bh_justification}
                />
                <EditorSection 
                    sectionName={editorSections.chemical_hazard}
                    onClick={ () => { handleOnClick('chemical_hazard')}}
                    html={sopState?.chemical_hazard}
                    onUpdate={ (val) => { handleOnUpdate('chemical_hazard', val) }}
                    attachment={chemical_hazard}
                />
                <YesNoSwitcher 
                    label={editorSections.ch_rlto} 
                    checked={ (typeof sopState.ch_rlto === 'boolean') ? sopState.ch_rlto : false } 
                    onChange={ (e) => { 
                        handleOnUpdate('ch_rlto', e.target.checked)
                    }}  
                />
                <EditorSection 
                    sectionName={editorSections.ch_justification}
                    onClick={ () => { handleOnClick('ch_justification')}}
                    html={sopState?.ch_justification}
                    onUpdate={ (val) => { handleOnUpdate('ch_justification', val) }}
                    attachment={ch_justification}
                />
                <EditorSection 
                    sectionName={editorSections.physical_hazard}
                    onClick={ () => { handleOnClick('physical_hazard')}}
                    html={sopState?.physical_hazard}
                    onUpdate={ (val) => { handleOnUpdate('physical_hazard', val) }}
                    attachment={physical_hazard}
                />
                <YesNoSwitcher 
                    label={editorSections.ph_rlto} 
                    checked={ (typeof sopState.ph_rlto === 'boolean') ? sopState.ph_rlto : false } 
                    onChange={ (e) => { 
                        handleOnUpdate('ph_rlto', e.target.checked)
                    }}  
                />
                <EditorSection 
                    sectionName={editorSections.ph_justification}
                    onClick={ () => { handleOnClick('ph_justification')}}
                    html={sopState?.ph_justification}
                    onUpdate={ (val) => { handleOnUpdate('ph_justification', val) }}
                    attachment={ph_justification}
                />
                <EditorSection 
                    sectionName={editorSections.measures}
                    onClick={ () => { handleOnClick('measures')}}
                    html={sopState?.measures}
                    onUpdate={ (val) => { handleOnUpdate('measures', val) }}
                    attachment={measures}
                />
                <YesNoSwitcher 
                    label={editorSections.ccp} 
                    checked={ (typeof sopState.ccp === 'boolean') ? sopState.ccp : false } 
                    onChange={ (e) => { 
                        handleOnUpdate('ccp', e.target.checked)
                    }}  
                />
                {children}
            </form>
        </div>
    )
}